import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.CLIENT.EMAIL.BASE_URL;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.CLIENT.EMAIL.BASE_URL;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.CLIENT.EMAIL.BASE_URL;
}

const sendRequestEmail = req => {
  return axios.post(`${BASE_URL}/request/send`, req);
};

export default {
  sendRequestEmail
};
